module.exports = __webpack_public_path__ + "static/media/Vue-SDB_02-Rose-blush.99825000.jpg";